import SearchApi from "../Api/search-api";

let timers;
let events = null;
let isCursor = false;

let searchResultsDropdown = document.querySelector('.search-result');
if(searchResultsDropdown){
    searchResultsDropdown.onmouseover = () => isCursor = true;
    searchResultsDropdown.onmouseleave = () => {
        isCursor = false;
        setTimeout(() => searchResultsDropdown.classList.remove('active'), 200);
    }
}
const getSearchDropdown = () => {
    if (searchResultsDropdown) {
        return searchResultsDropdown.querySelector('.js_products');
    }
    return null;
};

const itemTemplate = item => {
    let priceBlock = `<div class="search-product__right d-flex flex-column align-items-end gap-5">
                                <div class="fs-16 fw-md lh-1_2">Цена по запросу</div>
                            </div>`;

    if (parseFloat(item.price) > 0) {
        priceBlock = `<div class="search-product__right d-flex flex-column align-items-end gap-5">
                        <div class="fs-16 fw-md lh-1_2">${item.price} ₸</div>
                        <button type="button" class="btn btn-main js_open_form"
                             name="pay_one_click"
                             data-product_id="${item.id}"
                             data-size="modal-dialog-centered modal-lg"
                        >Купить в 1 клик</button>
                    </div>`;
    }
    let addToCart = ''
    if (parseFloat(item.price) > 0 && parseInt(item.available) > 0) {
        addToCart = `<button type="button" class="btn-inline d-flex align-items-center gap-5 js_add_to_cart"
                         data-product_id="${item.id}"
                         data-id="${item.id}"
                     >
                        <i class="icon fs-18 cart"></i>
                        <span class="d-inline-block fs-14 lh-1_2">В корзину</span>
                    </button>`;
    }
    return `<div class="search-product d-flex align-items-center justify-content-between js_item">
                <div class="search-product__left d-flex align-items-center gap-10">
                    <a class="search-product__img rounded-6 d-none d-xxl-block" href="${item.url}">
                       <img src="${item.photo}" alt="${item.title}" loading="lazy">
                    </a>
                    <div class="d-flex flex-column gap-10">
                        <a class="fs-16 fw-md lh-1_2" href="${item.url}">${item.title}</a>
                        <div class="d-flex gap-15">
                            <button type="button" class="btn-inline d-flex align-items-center gap-5 js_add_compare"
                                data-type="${item.type}" data-id="${item.id}"
                            >
                                <i class="icon fs-18 leaderboard"></i>
                                <span class="d-inline-block fs-14 lh-1_2">Сравнить</span>
                            </button>
                            ${addToCart}
                        </div>
                    </div>
                </div>
                ${priceBlock}
            </div>`;
}

const search = searchPhrase => {
    let searchDropdown = getSearchDropdown();
    if (searchDropdown) {
        searchDropdown.classList.add('preloader');
        searchDropdown.innerHTML = '';
        SearchApi.autocomplete(searchPhrase)
            .then(e => e.json())
            .then(e => {
                if (e.success) {
                    let message = `<a class="d-flex justify-content-between gap-10">По вашему запросу ничего не найдено</a>`;
                    if (e.data.length) {
                        message = '';
                        e.data.forEach(item => {
                            item.price = item.price > 0 ? item.price += ' ₽' : '';
                            message += itemTemplate(item);
                        });
                    }

                    searchDropdown.innerHTML = message;
                    searchResultsDropdown.classList.add('active');

                    events.dispatch('filter.search');
                }
            })
            .finally(() => searchDropdown.classList.remove('preloader'));
    }
};

const inputEvent = event => {

    if (searchResultsDropdown) {
        clearTimeout(timers);
        let searchPhrase = event.target.value || '';
        let searchLink = document.querySelector('.js_search_link');

        if (searchLink) {
            searchLink.href = '/search.html?stext=' + searchPhrase;
        }

        if (searchPhrase.trim().length > 1) {
            timers = setTimeout(search.bind(null, searchPhrase), 500);
        }
    }
};

const focusEvent = event => {
    if (searchResultsDropdown && event.target.value.trim().length) {
        searchResultsDropdown.classList.add('active');
    }
};



const blurEvent = event => {

    let searchDropdown = getSearchDropdown();

    if (searchDropdown && !isCursor) {
        setTimeout(() => searchResultsDropdown.classList.remove('active'), 200);
    }
};

const clickSearchButton = event => {
    const searchField = event.target.closest('form').querySelector('[name="stext"]');
    if (searchField.value.length > 2) {
        window.location = "search.html?stext=" + searchField.value;
    }
};

const initEvents = () => {

    document.querySelectorAll('[name="stext"]').forEach(item => {
        item.addEventListener('input', inputEvent);
        item.addEventListener('focus', focusEvent);
        item.addEventListener('blur', blurEvent);
    });

    document.querySelectorAll('.search-button')
        .forEach(item => item.addEventListener('click', clickSearchButton));
};

const clearEvents = () => {
    document.querySelectorAll('[name="stext"]').forEach(item => {
        item.removeEventListener('input', inputEvent);
        item.removeEventListener('focus', focusEvent);
        item.removeEventListener('blur', blurEvent);
    });
    document.querySelectorAll('.search-button')
        .forEach(item => item.removeEventListener('click', clickSearchButton));
};

const Init = event => {
    events = event;
    clearEvents();
    initEvents();
};

export const searchAutocomplete = {
    init(event) {
        return Init(event);
    }
};
